module.exports = __webpack_public_path__ + "img/20241215_1.eec9e706.jpg";